module.exports = __webpack_public_path__ + "img/authCode.f89c4809.png";